import { NextAxios as http } from '@/utils/request';
import host from '@/utils/request/host';

export async function queryMemberInfo() {
  const data = await http.get<IUser.MemberInfo>(`${host.member}/member/base/info`);
  if (data) {
    if ('#' == data.realName) {
      data.realName = undefined;
    }
    if (-1 == data.memberId) {
      data.memberId = undefined;
    }
    if ('#' == data.phone) {
      data.phone = undefined;
    }
  }
  return data;
}

export function queryMemberCertify(identifyCodeList: string[]) {
  return http.post<string[]>(`${host.identify}/member/auth/finish/list`, { identifyCodeList });
}

export function queryLastCertify(identifyCode: string) {
  return http.post<number>(`${host.identify}/member/auth/latest/status`, { identifyCode });
}
